import styled from 'styled-components';

import { space3XL } from '@xing-com/tokens';

import { CompaniesByIndustriesSection } from './sections/companies-by-industries/companies-by-industries-section';
import { MostVisitedCompaniesSection } from './sections/most-visited-companies/most-visited-companies-section';
import { TopCompaniesSection } from './sections/top-companies/top-companies-section';

const LoggedOutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space3XL};
  width: 100%;
`;
export const NewLoggedOutLandingPage = () => {
  return (
    <LoggedOutContainer data-testid="new-logged-out">
      <TopCompaniesSection />
      <MostVisitedCompaniesSection />
      <CompaniesByIndustriesSection />
    </LoggedOutContainer>
  );
};
